import { NavLink } from "react-router-dom";

const links = [
  ["Discover", "/"],
  ["Reports", "/reports"],
  ["Archive", "/archive"],
  ["Pro", "/pro"],
  ["More", "/methodology"],
] as const;

export function MobileBottomNav() {
  return (
    <nav className="mobile-bottom-nav" aria-label="Mobile navigation">
      {links.map(([label, path]) => (
        <NavLink key={path} end={path === "/"} to={path} className={({ isActive }) => `mobile-bottom-nav-link ${isActive ? "mobile-bottom-nav-link-active" : ""}`}>
          <span className="mobile-bottom-nav-mark" aria-hidden="true">{label === "More" ? "•••" : label.slice(0, 1)}</span>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
